
const state = {};

export default class InteractiveMapWithAccordion {
    static init() {
        // Ignore if not in Neos backend
        if (!window?.neos?.guestFrame?.findElementByNode) {
            return;
        }

        document.addEventListener('Neos.NodeCommit', (event) => {
            const {node, property} = event.detail;

            if (node.nodeType !== 'CodeQ.Site:Content.InteractiveMapWithAccordion.Item') {
                return;
            }

            this.updateMapItem(node, property)
        })

        document.addEventListener('Neos.NodeDiscard', (event) => {
            const {node, properties} = event.detail;

            if (node.nodeType !== 'CodeQ.Site:Content.InteractiveMapWithAccordion.Item') {
                return;
            }

            properties.forEach(property => {
                this.updateMapItem(node, property)
            })
        })
    }

    static updateMapItem(node, property) {
        state[node.identifier] = state[node.identifier] || {
            horizontalPosition: node.properties.horizontalPosition/10,
            verticalPosition: node.properties.verticalPosition/10,
        };
        const {name, updated} = property;
        switch(name) {
            case 'horizontalPosition': state[node.identifier].horizontalPosition = updated/10; break;
            case 'verticalPosition': state[node.identifier].verticalPosition = updated/10; break;
        }
        const {horizontalPosition, verticalPosition} = state[node.identifier];

        // keep this in synx with InteractiveMapWithAccordion.MapPin.fusion
        const svgViewboxSize = {
            width: 1076,
            height: 605,
        };
        const pinSize = {
            width: 27.5,
            height: 36,
        };
        const pinPosition = {
            top: verticalPosition * svgViewboxSize.height / 100 + (pinSize.height / 2),
            left: horizontalPosition * svgViewboxSize.width / 100 + (pinSize.width / 2),
        };
        const element = window.neos.guestFrame.findElementByNode(node)
        const transform = `translate(${pinPosition.left},${pinPosition.top})`;
        element.setAttribute('data-transform', transform);
        element.closest('.imwa').dispatchEvent(new CustomEvent('imwa-force-re-render', {}));
    }
}
